import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useLenis } from "lenis/react";
import { useNavigate, useLocation } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";

const links = [
  { label: "Colecție", id: "colectie" },
  { label: "Manifest", id: "manifest" },
  { label: "Contact", id: "contact" },
];

export default function Navbar() {
  const { count, setOpen } = useCart();
  const lenis = useLenis();
  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: id } });
    } else if (lenis) {
      lenis.scrollTo(`#${id}`, { offset: -80, duration: 1.2 });
    }
  };

  const goHome = () => {
    if (location.pathname !== "/") navigate("/");
    else if (lenis) lenis.scrollTo(0, { duration: 1.2 });
  };

  const solid = scrolled || location.pathname !== "/";

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, ease: [0.19, 1, 0.22, 1], delay: 0.2 }}
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        solid ? "backdrop-blur-xl bg-[#EDEAE3]/80 border-b border-black/10" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 h-20 flex items-center justify-between">
        <button
          data-testid="logo-home"
          onClick={goHome}
          className="text-left leading-none"
        >
          <span className="block font-serif text-xl md:text-2xl tracking-tight text-[#0E0F12]">
            deter<span className="text-gramur">-ecobox</span>.ro
          </span>
          <span className="block text-[10px] tracking-[0.4em] uppercase text-[#4A4844] mt-1">
            Maison de Soin
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className="dd-line-hover text-sm tracking-widest uppercase text-[#4A4844] hover:text-[#0E0F12] transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="open-cart-button"
          onClick={() => setOpen(true)}
          className="relative flex items-center gap-3 group"
        >
          <span className="hidden sm:block text-xs tracking-widest uppercase text-[#4A4844] group-hover:text-[#0E0F12] transition-colors">
            Coș
          </span>
          <span className="relative">
            <ShoppingBag className="w-5 h-5 text-[#0E0F12]" strokeWidth={1.2} />
            {count > 0 && (
              <span
                data-testid="cart-count-badge"
                className="absolute -top-2 -right-2 w-4 h-4 rounded-full bg-gramur text-[#0E0F12] text-[10px] font-semibold flex items-center justify-center"
              >
                {count}
              </span>
            )}
          </span>
        </button>
      </div>
    </motion.header>
  );
}
